var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrightness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2017_893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2017_893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.85 22.85C11.3333 22.85 9.91675 22.566 8.60025 21.998C7.28392 21.4298 6.13883 20.6588 5.165 19.685C4.19117 18.7112 3.42017 17.5661 2.852 16.2497C2.284 14.9332 2 13.5167 2 12C2 10.4833 2.284 9.06674 2.852 7.75024C3.42017 6.43391 4.19117 5.28883 5.165 4.31499C6.13883 3.34116 7.28392 2.57016 8.60025 2.00199C9.91675 1.43399 11.3333 1.14999 12.85 1.14999C14.3667 1.14999 15.7832 1.43399 17.0997 2.00199C18.4161 2.57016 19.5612 3.34116 20.535 4.31499C21.5088 5.28883 22.2798 6.43391 22.848 7.75024C23.416 9.06674 23.7 10.4833 23.7 12C23.7 13.5167 23.416 14.9332 22.848 16.2497C22.2798 17.5661 21.5088 18.7112 20.535 19.685C19.5612 20.6588 18.4161 21.4298 17.0997 21.998C15.7832 22.566 14.3667 22.85 12.85 22.85ZM12.85 19.7C15.0167 19.7 16.8417 18.9583 18.325 17.475C19.8083 15.9917 20.55 14.1667 20.55 12C20.55 9.83333 19.8083 8.00833 18.325 6.52499C16.8417 5.04166 15.0167 4.29999 12.85 4.29999C10.6833 4.29999 8.85833 5.04166 7.375 6.52499C5.89167 8.00833 5.15 9.83333 5.15 12C5.15 14.1667 5.89167 15.9917 7.375 17.475C8.85833 18.9583 10.6833 19.7 12.85 19.7Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.44a2b6c30638cc49346837b053700325.svg";
export { ForwardRef as ReactComponent };